import { useTheme } from '@mui/styles';
import { useMediaQuery } from '@mui/material';

export const useMediaBreakpoint = (size = 'sm') => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(theme.breakpoints.values[size]), {
    noSsr: true,
  });
};
